import { VoteWrapper } from "./components/VoteWrapper";
import { AdminLoginWrapper } from "./components/AdminLoginWrapper";
import { ResultChartWrapper } from "./components/ResultChartWrapper";

const AppRoutes = [
    {
        index: true,
        element: <VoteWrapper />
    },
    {
        path: '/admin',
        element: <AdminLoginWrapper />
    },
    {
        path: '/results',
        element: <ResultChartWrapper />
    }
];

export default AppRoutes;
